import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
//#region src/workspaces/useWorkspaceInvitationsQuery.ts
var r = () => t({
	queryKey: e.invitations(),
	queryFn: n.getInvitations
});
//#endregion
export { r as useWorkspaceInvitationsQuery };
